var customCodFormProvinces = {
        data: {
  "San Jose": {
    "San Jose": {
      "Pavas": true,
      "Hatillo": true,
      "San": true,
      "Uruca": true,
      "Hospital": true,
      "San Francisco de D": true,
      "Zapote": true,
      "Catedral": true,
      "Merced": true,
      "Mata Redonda": true,
      "El Carmen": true
    },
    "Perez Zeledon": {
      "San": true,
      "Daniel": true,
      "Cajon": true,
      "Pejibaye": true,
      "Rivas": true,
      "El General": true,
      "Paramo": true,
      "La  Amistad": true
    },
    "Alajuelita": {
      "San": true,
      "Concepcion": true,
      "Alajuelita": true,
      "San Josecito": true,
      "San Antonio": true
    },
    "Desamparados": {
      "San": true,
      "Desamparados": true,
      "San Rafael Abajo": true,
      "San Juan de Dios": true,
      "San Rafael Arriba": true,
      "Gravilias": true,
      "Damas": true,
      "Patarra": true,
      "San Antonio": true,
      "Frailes": true,
      "Rosario": true
    },
    "Goicoechea": {
      "Purral": true,
      "Ipis": true,
      "Calle Blancos": true,
      "Guadalupe": true,
      "Mata de Platano": true,
      "Rancho Redondo": true,
      "San Francisco": true
    },
    "Curridabat": {
      "Curridabat": true,
      "Tirrases": true,
      "Granadilla": true,
      "Sanchez": true
    },
    "Moravia": {
      "San": true,
      "La Trinidad": true,
      "San Jeronimo": true
    },
    "Aserri": {
      "Aserri": true,
      "Salitrillos": true,
      "Vuelta de Jorco": true,
      "San Gabriel": true,
      "Tarbaca": true
    },
    "Escazu": {
      "San Rafael": true,
      "San Antonio": true,
      "Escazu": true
    },
    "Montes de Oca": {
      "San Pedro": true,
      "Sabanilla": true,
      "San Rafael": true,
      "Mercedes": true
    },
    "Tibas": {
      "San Juan": true,
      "Colima": true,
      "Anselmo Llorente": true,
      "Cinco Esquinas": true
    },
    "Vazquez de Corona": {
      "Patalillo": true,
      "San Isidro": true,
      "Dulce Nombre de": true,
      "San Rafael": true,
      "Cascajal": true
    },
    "Santa Ana": {
      "Pozos": true,
      "Santa Ana": true,
      "Piedades": true,
      "Uruca": true,
      "Salitral": true,
      "Brasil": true
    },
    "Mora": {
      "Colon": true,
      "Guayabo": true,
      "Tabarcia": true,
      "Jaris": true,
      "Quitirrisi": true
    },
    "Puriscal": {
      "Santiago": true,
      "Mercedes Sur": true,
      "San Antonio": true,
      "Barbacoas": true,
      "San Rafael": true,
      "Candelarita": true,
      "Desamparaditos": true
    },
    "Acosta": {
      "San Ignacio": true,
      "Palmichal": true
    },
    "Turrubares": {
      "San Juan de Mata": true,
      "San Luis": true
    }
  },
  "Guanacaste": {
    "Liberia": {
      "Liberia": true,
      "Canas Dulces": true,
      "Curubande": true,
      "Nacascolo": true,
      "Mayorga": true
    },
    "Carrillo": {
      "Sardinal": true,
      "Belen": true,
      "Filadelfia": true,
      "Palmira": true
    },
    "Bagaces": {
      "Bagaces": true,
      "Mogote": true,
      "La Fortuna": true
    },
    "La Cruz": {
      "La Cruz": true,
      "Santa Elena": true
    }
  },
  "Limon": {
    "Limon": {
      "Limon": true
    },
    "Pococi": {
      "Guapiles": true,
      "Jimenez": true
    },
    "Guacimo": {
      "Guacimo": true,
      "Pocora": true,
      "Mercedes": true
    }
  },
  "Heredia": {
    "Heredia": {
      "San": true,
      "Ulloa": true,
      "Mercedes": true,
      "Heredia": true
    },
    "San Pablo": {
      "San Pablo": true,
      "Rincon de Sabanil": true
    },
    "San Rafael": {
      "San Josecito": true,
      "Angeles": true,
      "San Rafael": true,
      "Santiago": true,
      "Concepcion": true
    },
    "Barva": {
      "San Pedro": true,
      "San Pablo": true,
      "Santa Lucia": true,
      "San Jose de la Mo": true,
      "San Roque": true,
      "Barva": true
    },
    "Santa Barbara": {
      "Jesus": true,
      "San Juan": true,
      "San Pedro": true,
      "Santa Barbara": true,
      "Puraba": true,
      "Santo Domingo": true
    },
    "Flores": {
      "Llorente": true,
      "San Joaquin": true,
      "Barrantes": true
    },
    "Belen": {
      "San Antonio": true,
      "La Ribera": true,
      "La Asuncion": true
    },
    "Santo Domingo": {
      "Santa Rosa": true,
      "San Vicente": true,
      "San Miguel": true,
      "Santo Tomas": true,
      "Santo Domingo": true,
      "Tures": true,
      "Para": true,
      "Paracito": true
    },
    "San Isidro": {
      "San Jose": true,
      "San Isidro": true,
      "San Francisco": true,
      "Concepcion": true
    }
  },
  "Alajuela": {
    "Alajuela": {
      "San": true,
      "Alajuela": true,
      "Desamparados": true,
      "Guacima": true,
      "San Isidro": true,
      "Tambor": true,
      "Rio Segundo": true,
      "Sabanilla": true,
      "Garita": true,
      "Turrucares": true,
      "Carrizal": true
    },
    "San Carlos": {
      "Ciudad": true
    },
    "Naranjo": {
      "Naranjo": true,
      "San Miguel": true,
      "Cirri Sur": true,
      "Palmitos": true,
      "El Rosario": true,
      "San Jeronimo": true,
      "San Jose": true
    },
    "Grecia": {
      "Grecia": true,
      "San Roque": true,
      "Puente de Piedra": true,
      "San Jose": true,
      "Tacares": true,
      "Bolivar": true,
      "San Isidro": true
    },
    "Poas": {
      "Carrillos": true,
      "San Pedro": true,
      "San Rafael": true,
      "San Juan": true,
      "Sabana Redonda": true
    },
    "San Ramon": {
      "San Rafael": true,
      "Piedades Norte": true,
      "San Ramon": true,
      "Alfaro": true,
      "San Isidro": true,
      "Angeles": true,
      "Santiago": true,
      "Piedades Sur": true,
      "Concepcion": true,
      "Volio": true
    },
    "Orotina": {
      "Orotina": true,
      "Coyolar": true,
      "La Ceiba": true,
      "Hacienda Vieja": true
    },
    "Palmares": {
      "Zaragoza": true,
      "Buenos Aires": true,
      "La Granja": true,
      "Palmares": true,
      "Santiago": true,
      "Candelaria": true
    },
    "Sarchi": {
      "Sarchi Norte": true,
      "San Pedro": true,
      "Rodriguez": true
    },
    "Atenas": {
      "Atenas": true,
      "Jesus": true,
      "Concepcion": true,
      "Mercedes": true,
      "San Isidro": true,
      "Santa Eulalia": true,
      "San Jose": true,
      "Escobal": true
    },
    "San carlos": {
      "Florencia": true,
      "Fortuna": true
    },
    "Zarcero": {
      "Zarcero": true,
      "Guadalupe": true
    },
    "San Mateo": {
      "San Mateo": true,
      "Jesus Maria": true,
      "Labrador": true,
      "Desmonte": true
    }
  },
  "Puntarenas": {
    "Esparza": {
      "Espiritu": true,
      "Caldera": true,
      "San Juan Grande": true,
      "Macacona": true,
      "San Rafael": true,
      "San Jeronimo": true
    },
    "Puntarenas": {
      "Barranca": true,
      "Chacarita": true,
      "El Roble": true
    },
    "Montes de Oro": {
      "Miramar": true
    }
  },
  "Cartago": {
    "Cartago": {
      "Aguacaliente": true,
      "Carmen": true,
      "Guadalupe o Aren": true,
      "Oriental": true,
      "Corralillo": true,
      "Dulce Nombre": true,
      "Occidental": true,
      "Quebradilla": true,
      "Tierra Blanca": true,
      "Llano Grande": true
    },
    "Oreamuno": {
      "San Rafael": true,
      "Cot": true,
      "Cipreses": true,
      "Santa Rosa": true,
      "Potrero Cerrado": true
    },
    "Turrialba": {
      "Turrialba": true,
      "La Suiza": true,
      "La Isabel": true,
      "Santa Rosa": true,
      "Santa Teresita": true,
      "Pavones": true,
      "Santa Cruz": true,
      "Tuis": true,
      "Tayutic": true,
      "Tres Equis": true,
      "Peralta": true
    },
    "El Guarco": {
      "El Tejar": true,
      "San Isidro": true,
      "Tobosi": true
    },
    "La Union": {
      "San Diego": true,
      "Concepcion": true,
      "San Rafael": true,
      "San Juan": true,
      "Rio Azul": true,
      "Tres Rios": true,
      "Dulce Nombre": true,
      "San Ramon": true
    },
    "Paraiso": {
      "Paraiso": true,
      "Orosi": true,
      "Santiago": true,
      "Cachi": true
    },
    "Jimenez": {
      "Juan Vinas": true,
      "Tucurrique": true,
      "Pejibaye": true
    },
    "Alvarado": {
      "Cervantes": true,
      "Pacayas": true,
      "Capellades": true
    }
  }
},
startFields: function () {
            document.querySelector('#_rsi-cod-form-modal [data-type="province_country_field"]').addEventListener("change", customCodFormProvinces.onProvinceChange);
            document.querySelector('#_rsi-cod-form-modal [data-type="city_country_field"]').addEventListener("change", customCodFormProvinces.onCityChange);
        },
        onProvinceChange: function () {
            var value = document.querySelector('#_rsi-cod-form-modal [data-type="province_country_field"]').value;

            var html = "";

            if (!customCodFormProvinces.data[value]) {
                html += '<option value="">' + _COD_FORM_CITY_LABEL + '</option>';
                document.querySelector('#_rsi-cod-form-modal [data-type="city_country_field"]').innerHTML = html;
                document.querySelector('#_rsi-cod-form-modal [data-type="city_country_field"]').value = "";
                customCodFormProvinces.onCityChange();
                return;
            }

            html += '<option value="">' + _COD_FORM_CITY_LABEL + '</option>';

            Object.keys(customCodFormProvinces.data[value]).sort().forEach(function (item) {
                html += '<option value="' + item + '">' + item + '</option>';
            });

            document.querySelector('#_rsi-cod-form-modal [data-type="city_country_field"]').innerHTML = html;
            document.querySelector('#_rsi-cod-form-modal [data-type="city_country_field"]').value = "";
            customCodFormProvinces.onCityChange();
        },
        onCityChange: function () {
            var provValue = document.querySelector('#_rsi-cod-form-modal [data-type="province_country_field"]').value;
            var value = document.querySelector('#_rsi-cod-form-modal [data-type="city_country_field"]').value;

            var html = "";

            if (!customCodFormProvinces.data[provValue]) {
                html += '<option value="">' + _COD_FORM_ZIP_LABEL + '</option>';
                document.querySelector('#_rsi-cod-form-modal [data-type="civic_number_country_field"]').innerHTML = html;
                document.querySelector('#_rsi-cod-form-modal [data-type="civic_number_country_field"]').value = "";
                return;
            }

            if (!customCodFormProvinces.data[provValue][value]) {
                html += '<option value="">' + _COD_FORM_ZIP_LABEL + '</option>';
                document.querySelector('#_rsi-cod-form-modal [data-type="civic_number_country_field"]').innerHTML = html;
                document.querySelector('#_rsi-cod-form-modal [data-type="civic_number_country_field"]').value = "";
                return;
            }

            html += '<option value="">' + _COD_FORM_ZIP_LABEL + '</option>';

            Object.keys(customCodFormProvinces.data[provValue][value]).sort().forEach(function (item) {
                html += '<option value="' + item + '">' + item + '</option>';
            });

            document.querySelector('#_rsi-cod-form-modal [data-type="civic_number_country_field"]').innerHTML = html;
            document.querySelector('#_rsi-cod-form-modal [data-type="civic_number_country_field"]').value = "";
        }
    };

    function _COD_FORM_ON_OPEN_INIT_END_DEF() {
        customCodFormProvinces.startFields();
    }

    var _COD_FORM_CITY_LABEL = "";
    var _COD_FORM_ZIP_LABEL = "";

    function _COD_FORM_OVERWRITE_INIT() {

        _rsi.s.form.fields.items_array.forEach(function (item) {
            if (item.type == "province_country_field" || item.type == "province") {
                item.type = "province_country_field";
                item.backendFields.name = "province_country_field";
                item.backendFields.elementType = "select";
                var options = [];
                Object.keys(customCodFormProvinces.data).sort().forEach(function (i) {
                  options.push({
                      value: i, label: i
                  });
              });
                item.backendFields.options = options;
            } else if (item.type == "city") {
                item.type = "city_country_field";
                item.backendFields.name = "city";
                item.backendFields.elementType = "select";
                _COD_FORM_CITY_LABEL = item.n.ph;
                var options = [{
                    value: "", label: _COD_FORM_CITY_LABEL
                }];
                item.backendFields.options = options;
            } else if (item.type == "civic_number") {
                item.type = "civic_number_country_field";
                item.backendFields.name = "civic_number";
                item.backendFields.elementType = "select";
                _COD_FORM_ZIP_LABEL = item.n.ph;
                var options = [{
                    value: "", label: _COD_FORM_ZIP_LABEL
                }];
                item.backendFields.options = options;
            }
        });

        return true;
    }